export const CNC_HISTORY_REQUEST = "CNC_HISTORY_REQUEST";
export const CNC_HISTORY_SUCCESS = "CNC_HISTORY_SUCCESS";
export const CNC_HISTORY_FAILED = "CNC_HISTORY_FAILED";